import { select } from '@ngrx/store';
import { pipe } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { sessionAuthFeature } from '../reducers/session-auth.reducer';
import { sessionInfoFeature } from '../reducers/session-info.reducer';

export const tokenSelector = sessionAuthFeature.selectToken;

export const isNativeClientSelector = sessionInfoFeature.selectIsNativeClient;
export const selectIsNativeClient = pipe(
  select(isNativeClientSelector),
  filter((isNativeClient) => isNativeClient != null),
  take(1),
);

export const secondFactorStateSelector =
  sessionAuthFeature.selectSecondFactorState;
